module.exports = __webpack_public_path__ + "img/hortiImage.a4b98812.svg";